var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75%",
    viewBox: "0 0 227.54 161.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M541.84,210.7V353.81c-3.24,6.83-9.11,9.2-18.34,9.16q-95.16-.45-190.33,0c-9.37,0-15.48-2.19-18.87-9.16v-112a35,35,0,0,0,.59-4.39c.16-8.58.15-17.16.37-25.74.13-4.82,4.14-8.56,10-9.41a54.17,54.17,0,0,1,7.55-.4c63.33,0,126.67.07,190-.22C532,201.57,538.33,203.76,541.84,210.7ZM527.43,351.79V231.42H328.76V351.79ZM477.84,216.41c0-3.74-4.37-7.25-9.08-7.23-4.44,0-8.62,3.39-8.73,7-.12,3.91,4,7.4,8.73,7.45S477.79,220.2,477.84,216.41Zm49.82-.09c0-3.66-4.14-7-8.72-7.13-4.76-.08-9,3.37-9,7.35s4.2,7.21,9.22,7.09C523.62,223.53,527.66,220.05,527.66,216.32Zm-25.09.15c-.1-3.91-4.49-7.51-9-7.4s-8.79,3.91-8.57,7.71,4.38,6.86,9,6.81S502.68,220.19,502.57,216.47Z",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.43,351.79H328.76V231.42H527.43Zm-118.2-85.07a9.9,9.9,0,0,0-2,.18q-22.27,7.69-44.53,15.44c-4.74,1.65-1.85,5-2.52,7.55-.55,2.07.4,3.47,3.14,4.39,13.82,4.66,27.54,9.52,41.31,14.28,1.29.44,2.68.7,4.59,1.19a59.39,59.39,0,0,1,.06-7.5c.36-2.7-1.18-3.82-4.1-4.68-6.95-2-13.8-4.3-20.67-6.53-2.53-.81-5-1.76-8.57-3,10.75-3.39,20.31-6.36,29.8-9.48,1.34-.44,3.17-1.52,3.3-2.44A69.15,69.15,0,0,0,409.23,266.72Zm71.17,21.33c-2.46.93-3.91,1.55-5.42,2-8.13,2.61-16.31,5.11-24.38,7.85-1.42.48-3.18,1.81-3.36,2.9-.46,2.9-.16,5.89-.16,9.16,1.7-.48,3.12-.82,4.47-1.29,13.6-4.75,27.15-9.59,40.8-14.24,2.79-.95,4.15-2.19,3.58-4.58-.67-2.79,1.68-6.19-3.64-7.93-13.72-4.5-27.25-9.37-40.87-14.06-1.28-.44-2.64-.71-4.49-1.2a31.5,31.5,0,0,1-.05,5.48c-.78,4,1.07,6,6,7.31C461.91,281.85,470.62,285,480.4,288.05Zm-65.46,26.47c1.11.91,2.51,3,4,3,1.95,0,4.18-1.32,5.82-2.5,1-.71,1.19-2.2,1.54-3.39q7-23.77,13.91-47.57c.67-2.33,1.7-5-2.77-5.89-4.12-.82-5.82,1-6.7,3.87-2.83,9.36-5.77,18.7-8.59,28.06C419.77,297.91,417.53,305.71,414.94,314.52Z",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.56,209.07",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.8991617560386658px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,216.78",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "0.8991617560386658px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,266.72a69.15,69.15,0,0,1-.16,9.36c-.13.92-2,2-3.3,2.44-9.49,3.12-19,6.09-29.8,9.48,3.57,1.28,6,2.23,8.57,3,6.87,2.23,13.72,4.49,20.67,6.53,2.92.86,4.46,2,4.1,4.68a59.39,59.39,0,0,0-.06,7.5c-1.91-.49-3.3-.75-4.59-1.19-13.77-4.76-27.49-9.62-41.31-14.28-2.74-.92-3.69-2.32-3.14-4.39.67-2.55-2.22-5.9,2.52-7.55q22.26-7.72,44.53-15.44A9.9,9.9,0,0,1,409.23,266.72Z",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.4,288.05c-9.78-3.1-18.49-6.2-27.5-8.57-4.95-1.31-6.8-3.29-6-7.31a31.5,31.5,0,0,0,.05-5.48c1.85.49,3.21.76,4.49,1.2,13.62,4.69,27.15,9.56,40.87,14.06,5.32,1.74,3,5.14,3.64,7.93.57,2.39-.79,3.63-3.58,4.58-13.65,4.65-27.2,9.49-40.8,14.24-1.35.47-2.77.81-4.47,1.29,0-3.27-.3-6.26.16-9.16.18-1.09,1.94-2.42,3.36-2.9,8.07-2.74,16.25-5.24,24.38-7.85C476.49,289.6,477.94,289,480.4,288.05Z",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.94,314.52c2.59-8.81,4.83-16.61,7.18-24.4,2.82-9.36,5.76-18.7,8.59-28.06.88-2.9,2.58-4.69,6.7-3.87,4.47.89,3.44,3.56,2.77,5.89q-6.85,23.81-13.91,47.57c-.35,1.19-.56,2.68-1.54,3.39-1.64,1.18-3.87,2.53-5.82,2.5C417.45,317.52,416.05,315.43,414.94,314.52Z",
    transform: "translate(-314.3 -201.62)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.069ef4fb81c237b1fe0a680705ea1cca.svg";
export { ForwardRef as ReactComponent };